import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import Welcome from '../../Molecules/Welcome/Welcome';
import ReactDOM from 'react-dom';
import { useAppContext } from '../../../hooks/AppContext';
import { useHistory } from 'react-router-dom';
import { getSetting } from '../../../utility';
import { segmentTracking } from '../../../lib/tracker';
import envizi from '../../../data/envizi.json';
import {
  Button,
  ButtonSet,
  InlineNotification,
  Modal,
  NumberInput,
  RadioTile,
  SkeletonPlaceholder,
  Tag,
  TileGroup,
  Toggle,
  Tooltip,
} from 'carbon-components-react';
import { segmentsTracking } from 'src/common/lib/tracker';
import { FormattedMessage, useIntl } from 'react-intl';
import Footnote from '../../Molecules/Footnote/Footnote';
import {
  EST_BASE_APP_POINTS,
  MAX_SSC,
  MIN_SSC,
  Pkg,
  SOURCE_CONNECTION_APP_POINTS,
  STD_BASE_APP_POINTS,
  UT30Envzi,
  tileInfo,
} from 'src/apps/envizi-price-estimator/constant/spread';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import usePrice from 'src/apps/envizi-price-estimator/hooks/usePriceWithEstStdAppPoints';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import * as URX_FORM from '../../../constant/urx-form';
import { useBPName } from 'src/common/hooks/widgets/useBPName';
import { FormModal } from 'src/common/utils/FormModal';
import Cookies from 'js-cookie';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import ModalThanks from '../../Molecules/Thanks/ModalThanks';
import countryList from '../../../services/currencies.json';
import {
  LangDefaults,
  determineCountry,
  useLang,
} from 'src/common/hooks/widgets/useLang';

type HomePageProps = {
  tileValue: string;
  setTileValue: React.Dispatch<React.SetStateAction<string>>;
  langCode: string;
  countryToTest: string;
  test: boolean;
};

const HomePage = ({
  tileValue,
  setTileValue,
  langCode,
  countryToTest,
  test,
}: HomePageProps) => {
  const history = useHistory();
  const { appState, appAction } = useAppContext();
  const [packageName, setPackageName] = useState('Essentials');
  const [appPoints, setAppPoints] = useState(0);
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [urxlang] = useState(localeCode.toString());
  const [dataAutomation, setDataAutomation] = useState(false);
  const isSmall = useSmallBreakpoint('560px');
  const [sourceConn, setSourceConn] = useState(1);
  const [showPrice, setShowPrice] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [formComplete, setFormComplete] = useState(false);
  const [environment] = useEnv();
  const cookieURL = useCookiesURL();
  const sourceConnRef = useRef() as MutableRefObject<HTMLInputElement>;
  const { bpName, companyId, logo } = useBPName(UT30Envzi, true);
  const [open, setOpen] = useState(false);
  const [currency, setCurrency] = useState('');
  const [country, setCountry] = useState('');

  // lang and userlocale is based out of ddo
  const [lang, userLocale] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  const [totalCost, totalCostMonthly, loading] = usePrice({
    appPoints,
    localeCode,
    currency,
    tileValue,
    country,
  });
  const intl = useIntl();
  const [localCurrency, setlocalCurrency] = useState<string>(localeCode);

  const [toggleCountry, setToggleCountry] = useState(false);
  const [modalLocalCountry, setModalLocalCountry] = useState('');
  const [modalLocalCurrency, setModalLocalCurrency] = useState('USD');
  const [modalLocalLanguage, setModalLocalLanguage] = useState('English');

  const [localExist, setLocalExist] = useState(false);
  let localStorageFound = localStorage.getItem('langLocale');
  if (localStorageFound === null)
    localStorageFound = LangDefaults.localCountryLang;
  const [selectedLocale, setSelectedLocale] = useState(localStorageFound);

  // Determine Country
  determineCountry(
    setLocalExist,
    setSelectedLocale,
    setModalLocalCountry,
    setModalLocalLanguage,
    setModalLocalCurrency,
    setToggleCountry,
    lang,
    countryList,
    true,
    test,
    localeCode,
  );

  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);

  useEffect(() => {
    fetch(
      'https://cos-dsh.s3.us-south.cloud-object-storage.appdomain.cloud/envizi.json',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      },
    )
      .then((res) => res.json())
      .then((data) =>
        appAction({
          type: 'appData',
          data: data,
        }),
      )
      .catch((error) => {
        // loading the json file in case if we have any api issue
        if (error) {
          appAction({
            type: 'appData',
            data: envizi,
          });
        }
      });
  }, []);

  window.urxEnvironment = environment;
  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
    setDrawerOpen(false); // Hide Drawer on Thank you page
  };

  useEffect(() => {
    setCookie();
  }, [tileValue, dataAutomation, sourceConn, totalCost, totalCostMonthly]);

  const setCookie = () => {
    const dataAutomationVal = dataAutomation ? 'Yes' : 'No';
    const stdinfo = dataAutomation
      ? ' Data capture automation as a service: ' +
        dataAutomationVal +
        ' | Source system Connections: ' +
        sourceConn
      : ' Data capture automation as a service: ' + dataAutomationVal;
    const additionalInfo = tileValue === tileInfo.std ? stdinfo : '';
    const packageStr =
      tileValue === tileInfo.std ? ' | Package: ' : ' Package: ';
    Cookies.set(
      'urxdcq',
      JSON.stringify({
        source: URX_FORM.FORM_ID,
        // One field to provide all values (stringify)
        dcq: {
          Q_NOTESDATA:
            cookieURL +
            additionalInfo +
            packageStr +
            packageName +
            ' | Estimated Monthly cost: ' +
            totalCostMonthly +
            ' | Estimated Annual cost: ' +
            totalCost,
        },
      }),
    );
  };

  const handleModal = () => {
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Start estimate',
      location: 'Estimator',
      action: '',
      field: '',
    });
    history.push('/input');
  };

  const handleModal1 = () => {
    setOpen(true);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Modal open ' + modalLocalCountry,
      location: 'Estimator',
      action: '',
      field: '',
    });
  };

  useEffect(() => {
    if (sourceConn <= MAX_SSC) {
      setShowPrice(true);
    } else {
      setShowPrice(false);
    }
  }, [dataAutomation, sourceConn]);

  const invalidSSC =
    parseInt(sourceConnRef?.current?.value) < MIN_SSC ||
    parseInt(sourceConnRef?.current?.value) > MAX_SSC ||
    sourceConnRef?.current?.value === '';

  useEffect(() => {
    if (tileValue === tileInfo.est) {
      setAppPoints(EST_BASE_APP_POINTS);
      setSourceConn(0);
    } else if (tileValue === tileInfo.std) {
      setAppPoints(STD_BASE_APP_POINTS);
      setDataAutomation(false);
    } else {
      setSourceConn(0);
    }
  }, [tileValue]);

  useEffect(() => {
    if (tileValue === tileInfo.std) {
      if (sourceConn >= 0 && dataAutomation) {
        const total = sourceConn * SOURCE_CONNECTION_APP_POINTS;
        setAppPoints(STD_BASE_APP_POINTS + total);
      }
    }
  }, [sourceConn, tileValue, dataAutomation]);

  const handleTakeMe = () => {
    if (tileValue === tileInfo.std && showPrice) {
      setTileValue(tileInfo.prem);
    }
  };

  const essentialFeature = [
    intl.formatMessage(messages.est_feat_pt1),
    intl.formatMessage(messages.est_feat_pt2),
    intl.formatMessage(messages.est_feat_pt3),
  ];

  const standardFeature = [
    intl.formatMessage(messages.std_feat_pt1),
    intl.formatMessage(messages.std_feat_pt2),
    intl.formatMessage(messages.std_feat_pt3),
    intl.formatMessage(messages.std_feat_pt4),
    intl.formatMessage(messages.std_feat_pt5),
    intl.formatMessage(messages.std_feat_pt6),
  ];

  type ModalStateManagerProps = {
    renderLauncher: any;
    children: React.ComponentType<LauncherContentProps>;
  };

  type LauncherContentProps = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };

  const ModalStateManager: React.FC<ModalStateManagerProps> = ({
    renderLauncher: LauncherContent,
    children: ModalContent,
  }) => {
    return (
      <>
        {!ModalContent || typeof document === 'undefined'
          ? null
          : ReactDOM.createPortal(
              <ModalContent open={open} setOpen={setOpen} />,
              document.body,
            )}
        {LauncherContent && <LauncherContent open={open} setOpen={setOpen} />}
      </>
    );
  };

  return (
    <>
      {formComplete ? (
        <ModalThanks
          licensePriceMonthly={`${totalCostMonthly}`}
          licensePriceYearly={`${totalCost}`}
          dataAutomation={dataAutomation}
          sourceConn={sourceConn}
          tileValue={tileValue}
          packageName={packageName}
          bpName={bpName}
        />
      ) : (
        <div className="bx--grid">
          <div className="bx--row modal-mt">
            <div
              className="bx--col-lg-4 bx--col-md-8 bx--col-sm-8 bx--offset-lg-12"
              id="countryModal"
            >
              {localExist && toggleCountry ? (
                <ModalStateManager
                  renderLauncher={() => (
                    <Button onClick={handleModal1}>
                      Access Page in
                      {' ' + modalLocalLanguage}
                    </Button>
                  )}
                >
                  {({ open, setOpen }) => (
                    <Modal
                      open={open}
                      onRequestClose={() => setOpen(false)}
                      modalLabel={`Found country ${modalLocalCountry}. Access page in ${modalLocalLanguage} (${modalLocalCurrency})`}
                      modalHeading={`The Envizi Price estimator is available in ${modalLocalLanguage} with local currency ${modalLocalCurrency}`}
                      size={'sm'}
                      primaryButtonText={'Cool! Take me there'}
                      secondaryButtonText={'Stay here'}
                      onRequestSubmit={() => {
                        localStorage.setItem('langLocale', selectedLocale);
                        (window.location.href =
                          'https://www.ibm.com/' +
                          selectedLocale +
                          '/products/envizi/pricing'),
                          segmentTracking('CTA Clicked', {
                            pageTitle: 'Envizi Price Estimator',
                            object: 'Envizi page',
                            resultValue: 'CTA clicked',
                            CTA: 'Switched to country ' + modalLocalCountry,
                            location: 'Estimator',
                            action: '',
                            field: '',
                          });
                        return true;
                      }}
                      onSecondarySubmit={() => {
                        segmentTracking('CTA Clicked', {
                          pageTitle: 'Envizi Price Estimator',
                          object: 'Envizi page',
                          resultValue: 'CTA clicked',
                          CTA: 'Stay here button clicked ' + modalLocalCountry,
                          location: 'Estimator',
                          action: '',
                          field: '',
                        });
                        setOpen(false);
                        return true;
                      }}
                    ></Modal>
                  )}
                </ModalStateManager>
              ) : null}
            </div>
          </div>
          <div className="bx--row mar3">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-4">
              <div className="page_sub_heading marginleft_1">
                <FormattedMessage {...messages.envizi_heading} />
              </div>
              <p className="page_body padding_24_3 mar2 marginleft_1">
                <FormattedMessage {...messages.envizi_sub_heading} />
              </p>
              <div className="bx--row mar3">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-4">
                  <TileGroup
                    className="envizi_widget__tilegrouphome"
                    name="radio tile group"
                    valueSelected={tileValue}
                  >
                    <RadioTile
                      className="envizi_widget__tile"
                      id="radio-tile-1"
                      value="essentials"
                      onClick={() => {
                        setTileValue(tileInfo.est);
                        setPackageName('Essentials');
                        setAppPoints(EST_BASE_APP_POINTS);
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'Envizi Price Estimator',
                          object: 'Envizi page',
                          resultValue: 'CTA clicked',
                          CTA: 'Essential Tile',
                          location: 'Estimator',
                          action: '',
                          field: '',
                        });
                      }}
                    >
                      <div className="page_sub_heading mar9">{Pkg.est}</div>
                      <div className="page_body_2 mar8">
                        <FormattedMessage {...messages.est_tile_desc1} />
                      </div>
                      <div className="page_body_2">
                        <FormattedMessage {...messages.est_tile_desc2} />
                      </div>
                    </RadioTile>
                    <RadioTile
                      id="radio-tile-2"
                      value="standard"
                      className="envizi_widget__tile"
                      onClick={() => {
                        setTileValue(tileInfo.std);
                        setPackageName('Standard');
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'Envizi Price Estimator',
                          object: 'Envizi page',
                          resultValue: 'CTA clicked',
                          CTA: 'Standard Tile',
                          location: 'Estimator',
                          action: '',
                          field: '',
                        });
                      }}
                    >
                      <div className="page_sub_heading mar9">{Pkg.std}</div>
                      <div className="page_body_2 mar8">
                        <FormattedMessage {...messages.std_tile_desc1} />
                      </div>
                      <div className="page_body_2">
                        <FormattedMessage {...messages.std_tile_desc2} />
                      </div>
                    </RadioTile>
                    <RadioTile
                      id="radio-tile-3"
                      value="premium"
                      onClick={() => {
                        setTileValue(tileInfo.prem);
                        setPackageName('Premium');
                        segmentsTracking('CTA Clicked', {
                          pageTitle: 'Envizi Price Estimator',
                          object: 'Envizi page',
                          resultValue: 'CTA clicked',
                          CTA: 'Premium Tile',
                          location: 'Estimator',
                          action: '',
                          field: '',
                        });
                      }}
                    >
                      <div className="page_sub_heading mar9">{Pkg.prem}</div>
                      <div className="page_body_2 mar8">
                        <FormattedMessage {...messages.prem_tile_desc1} />
                      </div>
                      <div className="page_body_2">
                        <FormattedMessage {...messages.prem_tile_desc2} />
                      </div>
                    </RadioTile>
                  </TileGroup>
                </div>
              </div>
              <div className="bx--row marTop">
                <div className="bx--col-lg-10 bx--col-md-16 bx--col-sm-16">
                  {tileValue === tileInfo.est ? (
                    <>
                      <div className="page_body_2 marginleft_1">
                        <FormattedMessage {...messages.features_label} />
                      </div>
                      <div className="marginleft_1">
                        {essentialFeature.map((item: string, index: number) => (
                          <Tag
                            key={index}
                            type={'purple'}
                            size="md"
                            disabled={false}
                            filter={false}
                            className="tag-margin"
                          >
                            {item}
                          </Tag>
                        ))}
                      </div>
                    </>
                  ) : tileValue === tileInfo.std ? (
                    <>
                      <div className="page_body_2 marginleft_1">
                        <FormattedMessage {...messages.features_label1} />
                      </div>
                      <div className="marginleft_1">
                        {standardFeature.map((item: string, index: number) => (
                          <Tag
                            key={index}
                            type={'purple'}
                            size="md"
                            disabled={false}
                            filter={false}
                            className="tag-margin"
                          >
                            {item}
                          </Tag>
                        ))}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="page_body_2 marginleft_1">
                        <Tag type="outline">{Pkg.prem}</Tag>
                        <br />
                        <br />
                        <div className="page_body_2">
                          <FormattedMessage {...messages.prem_feat} />
                        </div>
                      </div>
                    </>
                  )}
                  {tileValue === tileInfo.prem && (
                    <div className="marginleft_1">
                      <Welcome
                        title={getSetting(appState, 'AssetName')}
                        handleClick={handleModal}
                      />
                    </div>
                  )}
                  {tileValue === tileInfo.std && (
                    <>
                      <div className="bx--row mar3">
                        <div className="bx--col-lg-7 bx--col-md-16 bx--col-sm-16">
                          <Tooltip
                            onChange={() => {
                              segmentsTracking('CTA Clicked', {
                                pageTitle: 'Envizi Price Estimator',
                                object: 'Envizi page',
                                resultValue: 'CTA clicked',
                                CTA: 'Data Automation tooltip',
                                location: 'Estimator',
                                action: '',
                                field: '',
                              });
                            }}
                            direction={isSmall ? 'bottom' : 'right'}
                            tabIndex={0}
                            triggerText={
                              <span className="page_body marginleft_1">
                                <FormattedMessage
                                  {...messages.data_toogle_title}
                                />
                              </span>
                            }
                          >
                            <span className="slide_text marginleft_1">
                              <FormattedMessage
                                {...messages.data_tooltip_desc}
                              />
                            </span>
                          </Tooltip>
                          <Toggle
                            className="marginleft_1"
                            size="md"
                            labelA={intl.formatMessage(messages.no)}
                            labelB={intl.formatMessage(messages.yes)}
                            id="non-prod env"
                            toggled={dataAutomation}
                            onChange={() => {
                              segmentsTracking('CTA Clicked', {
                                pageTitle: 'Envizi Price Estimator',
                                object: 'Envizi page',
                                resultValue: 'CTA clicked',
                                CTA: 'Data Automation toggle',
                                location: 'Estimator',
                                action: '',
                                field: '',
                              });
                              setDataAutomation(!dataAutomation);
                              if (!dataAutomation) {
                                setAppPoints(STD_BASE_APP_POINTS);
                                setSourceConn(1);
                              } else {
                                setAppPoints(STD_BASE_APP_POINTS);
                                setSourceConn(0);
                              }
                            }}
                          />
                        </div>
                        <div className="bx--col-lg-2" />
                        <div className="bx--col-lg-7 bx--col-md-16 bx--col-sm-16 numinput-margin numinput-marleft">
                          <div className="page_body_2">
                            <FormattedMessage {...messages.ssc_label} />
                          </div>
                          <NumberInput
                            id="user"
                            size="md"
                            allowEmpty={true}
                            ref={sourceConnRef}
                            className="number-input"
                            disabled={!dataAutomation}
                            min={MIN_SSC}
                            max={MAX_SSC}
                            invalidText={intl.formatMessage(
                              messages.invalid_input_text,
                            )}
                            value={sourceConn}
                            onChange={() => {
                              segmentsTracking('CTA Clicked', {
                                pageTitle: 'Envizi Price Estimator',
                                object: 'Envizi page',
                                resultValue: 'CTA clicked',
                                CTA: 'Total Source system Connections',
                                location: 'Estimator',
                                action: '',
                                field: '',
                              });
                              setSourceConn(
                                Number(sourceConnRef.current.value),
                              );
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {tileValue === tileInfo.std &&
                    (sourceConn === MAX_SSC || invalidSSC) && (
                      <div className="bx--row mar6">
                        <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                          <InlineNotification
                            title={intl.formatMessage(messages.std_notif_desc)}
                            kind={'info-square'}
                            actions={
                              <p
                                className="notification-text"
                                onClick={handleTakeMe}
                              >
                                <FormattedMessage {...messages.std_notif} />
                              </p>
                            }
                          />
                        </div>
                      </div>
                    )}
                  {tileValue !== tileInfo.prem && (
                    <div id="footnote" className="div-only-lg">
                      <div className="bx--row">
                        <div className="bx--col-lg-16 marginleft_1 marTop">
                          <div>
                            <Footnote numNote={1} />
                          </div>
                          <div className="footnote_text">
                            <FormattedMessage {...messages.disclaimer_text} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="bx--col-lg-6 bx--col-md-16 bx--col-sm-16">
                  {tileValue === tileInfo.est ? (
                    <Tag type="outline" className="tag-margin1">
                      {Pkg.est}
                    </Tag>
                  ) : tileValue === tileInfo.std ? (
                    <Tag type="outline" className="tag-margin1">
                      {Pkg.std}
                    </Tag>
                  ) : null}
                  {tileValue === tileInfo.prem ? null : tileValue ===
                    tileInfo.est ? (
                    <div id="stickyNav" className="bx--row">
                      <div className="sticky-nav price_table_comp bg_white">
                        {' '}
                        <div id="price_toggle_one">
                          <div>
                            <p
                              id="widget.estimated-cost"
                              className="envizi_widget__ibm-type-e estmt-cost price_table_comp__bodycopy"
                            >
                              <FormattedMessage {...messages.estimateMonthly} />
                              <sup className="envizi_widget__sup">1</sup>
                            </p>
                            <div className="padding_8 price_table_comp__price">
                              {loading ? (
                                <SkeletonPlaceholder className="envizi_widget__sticky-nav-skeleton" />
                              ) : (
                                totalCostMonthly
                              )}
                            </div>
                            <p
                              id="widget.estimated-cost"
                              className="envizi_widget__ibm-type-e estmt-cost price_table_comp__bodycopy"
                            >
                              <FormattedMessage {...messages.estimateYearly} />
                              <sup className="envizi_widget__sup">1</sup>
                            </p>
                            <div className="padding_8 price_table_comp__price">
                              {loading ? (
                                <SkeletonPlaceholder className="envizi_widget__sticky-nav-skeleton" />
                              ) : (
                                totalCost
                              )}
                            </div>
                            <p className="price_table_comp__disclaimer price_table_comp_color padding_24_1">
                              *{' '}
                              <FormattedMessage {...messages.price_tax_text} />
                            </p>
                            <ButtonSet
                              className="envizi_widget__stack-button"
                              stacked
                            >
                              <Button
                                id="request_btn"
                                onClick={() => {
                                  segmentsTracking('CTA Clicked', {
                                    pageTitle: 'Envizi Pricing Page',
                                    object: 'Pricing page',
                                    resultValue: 'CTA clicked',
                                    CTA: 'Request a quote now',
                                    location: 'Estimator',
                                    action: '',
                                    field: '',
                                  });
                                  initUrxForm(
                                    environment,
                                    URX_FORM.INSTANCE_ID,
                                    URX_FORM.FORM_ID,
                                    urxlang as IBMLocale,
                                    companyId,
                                  );
                                  setDrawerOpen(true);
                                  setCookie();
                                }}
                              >
                                <FormattedMessage
                                  {...messages.quote_btn_text}
                                />
                              </Button>
                            </ButtonSet>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div id="stickyNav" className="bx--row">
                      <div className="sticky-nav price_table_comp bg_white">
                        <table className="cds--data-table cds--data-table--sm">
                          <thead>
                            <tr>
                              <th scope="col">
                                <div className="price_table_comp__heading">
                                  <FormattedMessage {...messages.col1_label1} />
                                </div>
                              </th>
                              <th scope="col">
                                <div className="cds--table-header-label">
                                  <div className="price_table_comp__heading">
                                    <FormattedMessage
                                      {...messages.col1_label2}
                                    />
                                  </div>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody aria-live="polite">
                            <tr>
                              <td>
                                <div className="price_table_comp__requirement price_table_comp_color padding_8">
                                  <FormattedMessage
                                    {...messages.data_toogle_title}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="price_table_comp__quantity padding_8">
                                  {dataAutomation ? (
                                    <FormattedMessage {...messages.yes} />
                                  ) : (
                                    <FormattedMessage {...messages.no} />
                                  )}
                                </div>
                              </td>
                            </tr>
                            {dataAutomation && (
                              <tr>
                                <td>
                                  {' '}
                                  <div className="price_table_comp__requirement price_table_comp_color padding_8">
                                    <FormattedMessage {...messages.ssc_label} />
                                  </div>
                                </td>
                                <td>
                                  <div className="price_table_comp__quantity padding_8">
                                    {sourceConn}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div id="price_toggle_one">
                          {showPrice ? (
                            <div>
                              {!invalidSSC && (
                                <>
                                  <p
                                    id="widget.estimated-cost"
                                    className="envizi_widget__ibm-type-e estmt-cost price_table_comp__bodycopy padding_24_2"
                                  >
                                    <FormattedMessage
                                      {...messages.estimateMonthly}
                                    />
                                    <sup className="envizi_widget__sup">1</sup>
                                  </p>
                                  <div className="padding_8 price_table_comp__price">
                                    {loading ? (
                                      <SkeletonPlaceholder className="envizi_widget__sticky-nav-skeleton" />
                                    ) : (
                                      totalCostMonthly
                                    )}
                                  </div>
                                  <p
                                    id="widget.estimated-cost"
                                    className="envizi_widget__ibm-type-e estmt-cost price_table_comp__bodycopy"
                                  >
                                    <FormattedMessage
                                      {...messages.estimateYearly}
                                    />
                                    <sup className="envizi_widget__sup">1</sup>
                                  </p>
                                  <div className="padding_8 price_table_comp__price">
                                    {loading ? (
                                      <SkeletonPlaceholder className="envizi_widget__sticky-nav-skeleton" />
                                    ) : (
                                      totalCost
                                    )}
                                  </div>
                                  <p className="price_table_comp__disclaimer price_table_comp_color padding_24_1">
                                    *{' '}
                                    <FormattedMessage
                                      {...messages.price_tax_text}
                                    />
                                  </p>
                                  <ButtonSet
                                    className="envizi_widget__stack-button"
                                    stacked
                                  >
                                    <Button
                                      id="request_btn"
                                      onClick={() => {
                                        segmentsTracking('CTA Clicked', {
                                          pageTitle: 'Envizi Pricing Page',
                                          object: 'Pricing page',
                                          resultValue: 'CTA clicked',
                                          CTA: 'Request a quote',
                                          location: 'Estimator',
                                          action: '',
                                          field: '',
                                        });
                                        initUrxForm(
                                          environment,
                                          URX_FORM.INSTANCE_ID,
                                          URX_FORM.FORM_ID,
                                          urxlang as IBMLocale,
                                          companyId,
                                        );
                                        setDrawerOpen(true);
                                        setCookie();
                                      }}
                                    >
                                      <FormattedMessage
                                        {...messages.quote_btn_text}
                                      />
                                    </Button>
                                  </ButtonSet>
                                </>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  )}
                  {tileValue !== tileInfo.prem && (
                    <div id="footnote" className="div-only-media">
                      <div className="bx--row pa-mar6">
                        <div className="bx--col-lg-9 marginleft_1">
                          <div>
                            <Footnote numNote={1} />
                          </div>
                          <div className="footnote_text">
                            <FormattedMessage {...messages.disclaimer_text} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <FormModal
        pageTitle="Envizi Price Estimator"
        object="Envizi Price Estimator Page"
        productTitle={'Envizi Price Estimator'}
        pageUrl={''}
        location={'Estimator'}
        bpName={bpName}
        logo={logo}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        formId={URX_FORM.FORM_ID}
        lang={lang}
      ></FormModal>
    </>
  );
};

export default HomePage;
